import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthProvider } from '@avayler/saas-nextjs-auth-cognito-client';
import { Button, Col, Image, Row, Spin, theme } from 'antd';
import IconLogo from 'pos-client/assets/Avayler-Icon-Logo.png';
import TitleLogo from 'pos-client/assets/Avayler-Name-Logo.png';
import LandingPageFooter from 'pos-client/assets/Avayler-Page-Footer.png';
import { clientConfig } from 'pos-client/clientConfig.ts';

const signIn = () => AuthProvider.signIn(clientConfig.bffBaseUrl);

const handleRedirect = () => AuthProvider.handleCode(clientConfig.bffBaseUrl);

const setRequestUrl = () => {
  const baseUrl = '/';
  const requestUrl = window.location.pathname + window.location.search;

  if (!localStorage.getItem('requestUrl') && baseUrl !== requestUrl) {
    localStorage.setItem('requestUrl', requestUrl);
  }
};
const isUrlForRedirect = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get('code');
  if (!code) {
    setRequestUrl();
  }
  return !!code;
};

interface LandingPageProps {
  loading?: boolean;
}

const LandingPage = ({ loading = false }: LandingPageProps) => {
  const { t } = useTranslation();
  const { token } = theme.useToken();
  const isHandlingRedirect = isUrlForRedirect();

  /*
     This is here because of STRICT MODE which causes double renders in dev mode
     which causes two requests to be fired with one ended up being a 400 and one being 200
     so you end up in a race condition scenario, this will make it only run once regardless.
     */
  const codeHandlingCalled = useRef(false);
  useEffect(() => {
    if (codeHandlingCalled.current) return;
    if (isHandlingRedirect) {
      handleRedirect();
    }
    codeHandlingCalled.current = true;
  }, [isHandlingRedirect]);

  return (
    <Row
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        width: '100vw',
        overflowX: 'hidden',
        background:
          'linear-gradient(270deg, rgba(218,237,255,1) 0%, rgba(254,255,255,0.7665660014005602) 52%, rgba(236,239,255,1) 100%)',
      }}
    >
      <Row style={{ flex: '1' }}>
        <Row align="middle" justify="center" style={{ height: '100%' }}>
          <Col style={{ width: '100vw' }}>
            <Row style={{ padding: token.paddingSM }} justify="center">
              <Image
                src={IconLogo}
                alt="Icon Logo"
                width={50}
                preview={false}
              />
            </Row>
            <Row style={{ padding: token.paddingSM }} justify="center">
              <Image
                src={TitleLogo}
                alt="Title Logo"
                width={200}
                preview={false}
              />
            </Row>
            <Row style={{ padding: token.paddingSM }} justify="center">
              {loading ? (
                <Spin size="large" />
              ) : (
                <Button
                  type="primary"
                  size="middle"
                  hidden={isHandlingRedirect}
                  style={{
                    width: '200px',
                    borderRadius: token.borderRadiusLG,
                    backgroundColor: '#00005D',
                  }}
                  onClick={signIn}
                >
                  {t('common.buttons.login')}
                </Button>
              )}
            </Row>
          </Col>
        </Row>
      </Row>
      <Image src={LandingPageFooter} preview={false} width="100.2vw" />
    </Row>
  );
};

export default LandingPage;
